import React from "react";
import studioData from "../data/studioData.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const iconMap = {
  instagram: faInstagram,
};

const Footer = () => {
  const footerContent = studioData.siteContent?.footer ?? {};

  return (
    <footer className="relative z-10 mx-auto w-full max-w-6xl px-6 pb-10">
      <div className="glass-panel flex flex-wrap items-center justify-between gap-4 px-5 py-4">
        <p className="text-xs uppercase tracking-[0.18em] text-text-secondary">
          {footerContent.brandLine ?? "blackpod.art • Architecture and Interiors"}
        </p>
        <div className="flex items-center gap-4">
          {studioData.socialLinks.map((social, index) => {
            const iconKey = social.icon?.toLowerCase();
            const icon = iconMap[iconKey];

            if (!icon) {
              return null;
            }

            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="me noopener noreferrer"
                className="glass-nav-item !h-9 !w-9 !p-0"
                aria-label={social.name}
                title={social.name}
              >
                <FontAwesomeIcon icon={icon} />
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
